import React from "react";
import { Modal, Button } from "react-bootstrap";

const constructChoices = (choices, hideModal) => {
  const buttons = [];

  for (const [, item] of choices.entries()) {
    buttons.push(
      <Button
        variant="link"
        onClick={() => {
          hideModal();
          item.onClick();
        }}
      >
        {item.label}
      </Button>
    );
  }

  return buttons;
};

const ChoicePopUp = props => {
  // const [modalShow, setModalShow] = React.useState(true);
  const choiceButtons = constructChoices(props.choices, props.handleClose);

  return (
    <Modal
      size="lg"
      centered
      show={props.show}
      onHide={() => {
        props.handleClose();

        props.onHide && props.onHide();
      }}
      backdrop={props.backdrop}
    >
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>

      {props.body != null && (
        <Modal.Body className="text-center">
          <p>{props.body}</p>
        </Modal.Body>
      )}

      <Modal.Footer className="justify-content-center">
        {choiceButtons}
      </Modal.Footer>
    </Modal>
  );
};

export default ChoicePopUp;
